var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextHFour = function SvgIconTextHFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.25a1 1 0 0 1 1 1v4.625h7.75V5.25a1 1 0 1 1 2 0V16.5a1 1 0 1 1-2 0v-4.625H4.75V16.5a1 1 0 1 1-2 0V5.25a1 1 0 0 1 1-1M20.208 8.432a1 1 0 0 1 .61 1.276l-1.78 5.042h2.087v-2a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0v-2h-3.5a1 1 0 0 1-.943-1.333l2.25-6.375a1 1 0 0 1 1.276-.61"
  }))));
};
export default SvgIconTextHFour;